import { render } from "./LanguageSection.vue?vue&type=template&id=61451add&scoped=true"
import script from "./LanguageSection.vue?vue&type=script&lang=js"
export * from "./LanguageSection.vue?vue&type=script&lang=js"

import "./LanguageSection.vue?vue&type=style&index=0&id=61451add&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61451add"]])

export default __exports__